import React from 'react'

const WhatsAppIcon = (props) => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
        <g
          stroke="#000"
          strokeWidth="1.5"
          fill="none"
          fillRule="evenodd"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M13.273 1.158a12.758 12.758 0 0 0-10.742 18.53l-1.354 6.573a.496.496 0 0 0 .6.583l6.441-1.526a12.755 12.755 0 1 0 5.055-24.16z" />
          <path d="m20.086 16.663-2.47-.71a.921.921 0 0 0-.912.24l-.604.616a.9.9 0 0 1-.978.207c-1.17-.472-3.628-2.657-4.255-3.752a.9.9 0 0 1 .071-.998l.527-.682a.92.92 0 0 0 .114-.936l-1.039-2.35a.921.921 0 0 0-1.438-.33c-.69.583-1.508 1.47-1.607 2.451-.175 1.731.567 3.913 3.374 6.532 3.242 3.028 5.84 3.43 7.53 3.018.96-.233 1.726-1.164 2.21-1.926a.921.921 0 0 0-.523-1.38h0z" />
        </g>
    </svg>
    )
}

export default WhatsAppIcon

